import React from "react";
import PropTypes from "prop-types";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import WhatsAppFab from "./WhatsAppFab";
import Lightbox from "./Lightbox";

export default function SiteLayout({ children }) {
  return (
    <>
      <SiteHeader />
      {children}
      <SiteFooter />
      <WhatsAppFab />
      <Lightbox />
    </>
  );
}

SiteLayout.propTypes = {
  children: PropTypes.node,
};
